module.exports = __webpack_public_path__ + "d68cc5b77846b686a53468dad1c83846.jpg";